import styled from 'styled-components';
import AlertTemplate from './DealerCommentTemplate';
import { rem } from 'polished';

export const DealerCommentStyled = styled(AlertTemplate)`
    border-top: ${(props) => (props.withoutBorderTop ? 'unset' : `${rem(1)} solid ${props.theme.colors.grey16}`)};
    border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .Collapsible__contentInner {
        padding-bottom: ${rem(45)};
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        text-transform: uppercase;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .wrapper {
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        .description {
            margin-bottom: ${rem(45)};
            margin-top: 0;
        }

        .section {
            padding: ${rem(22)};
            background: ${({ theme }) => theme.colors.grey8};

            .label {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                display: block;
                margin-bottom: ${rem(12)};
            }

            .comment {
                margin-bottom: 0;
            }
        }
    }
`;
